import auth from "./auth";
import api from "./api";

export default {
  fetchEstoreAnalyticsLink() {
    return new Promise((resolve, reject) => {
      api.get(
        "merchant-service/v1/cms/analytics/estore-quicksight/data",
        auth.getHeader()
      )
        .then(response => resolve(response))
        .catch((status, error) => reject(status, error));
    });
  }
}
